import { css } from 'styled-components';
import {
  ConfigurationCardIconWrapper,
  ConfigurationCardTitleWrapper,
} from './ConfigurationCardHeader.tsx';

/*
 * Frammenti `css` condivisi tra i due rami di rendering della
 * `ConfigurationCard` (Card antd per le pagine, Collapse antd per il
 * collassabile).
 */

/* Aspetto "card" comune ai due rami. */
export const cardChromeCss = css`
  box-shadow: ${props => props.theme.boxShadowTailwindMd};
  border: 1px solid ${props => props.theme.colorSplit};
  margin-bottom: 24px;
  border-radius: 8px;
`;

/* Vista densa: card a tutta larghezza nel Drawer.
   A chiudere l'ultima card è il border-top della riga pulsanti
   (vedi ConfigurationDrawerContent). */
export const denseFlatChromeCss = css`
  box-shadow: none;
  border-radius: 0;
  margin-bottom: 0;
  border: 3px solid ${props => props.theme.colorSplit};
  border-bottom: none;
`;

/* Riduzioni `dense` di icona e titolo dell'header, comuni ai due rami. */
export const denseHeaderPartsCss = css`
  ${ConfigurationCardIconWrapper} {
    width: 24px;
    height: 24px;
    margin-right: 4px;
    background-color: transparent;
    border-radius: 0px;
  }

  ${ConfigurationCardTitleWrapper} {
    min-height: 24px;
    .title {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      font-size: 15px;
    }
  }
`;
